export const DIALOG_STYLES = {
  overlay:
    "fixed inset-0 z-50 bg-black/40 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
  overlayStatic: "fixed inset-0 z-50 bg-black/40",
  content:
    "fixed z-50 grid gap-4 border bg-background p-6 shadow-lg duration-200",
  contentStatic: "fixed z-50 grid gap-4 border bg-background p-6 shadow-lg duration-0",
  contentBottomSheet:
    "left-0 bottom-0 w-full rounded-t-xl data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom max-h-[90vh] overflow-hidden",
  contentCentered:
    "inset-0 w-full m-auto max-w-lg max-h-[90vh] h-fit overflow-y-auto rounded-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
  contentCenteredStatic:
    "inset-0 w-full m-auto max-w-lg max-h-[90vh] h-fit overflow-y-auto rounded-lg",
  closeButton:
    "absolute right-4 hover:bg-gray-50 bg-white top-4 shadow-ticketon-card-alt p-3 rounded-full text-ticketon-lighter-blue text-[24px] ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground",
  header: "flex flex-col space-y-1.5 text-center sm:text-left",
  footer: "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
  title: "text-lg font-semibold leading-none tracking-tight",
  description: "text-sm text-muted-foreground",
} as const;
